"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupEventsBySport = groupEventsBySport;
/**
 * Creates ordered SportEventsGroup grouping events by same sport
 * @param events
 * @returns EventsGroup[]
 */
function groupEventsBySport(events) {
    if (events.length === 0)
        return [];
    const sportIndexes = [];
    const groupBySport = {};
    for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        const { sportId } = event.tournament;
        if (groupBySport[sportId] === undefined) {
            groupBySport[sportId] = [];
            sportIndexes.push(sportId);
        }
        groupBySport[sportId].push(event);
    }
    return sportIndexes.map((sportId) => ({
        sportId,
        events: groupBySport[sportId],
    }));
}
//# sourceMappingURL=groupBySport.js.map